module.exports = __webpack_public_path__ + "img/icon-payment-nfc.e6c6c2b8.png";